<table class="tiime-table" aria-label="Tableau lignes annexes">
  <thead>
    <tr tiimeTableHeaderRow>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="type">Type</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="label">Intitulé</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="chargeChoice">Type de charge</th>
      <th tiimeTableHeaderCell="discountPercentage"></th>
      @if (canRemoveLine()) {
        <th tiimeTableHeaderCell="actions"></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (lineForm of contractAnnexLineForms; track i; let i = $index) {
      <tr tiimeTableRow [formGroup]="lineForm">
        <td tiimeTableCell="type">
          <app-code-and-label-select
            label=""
            [allowEmptyOption]="false"
            [small]="true"
            [control]="lineForm.type"
            [options]="contractAnnexLineTypes"
          ></app-code-and-label-select>
        </td>
        <td tiimeTableCell="label">
          <input type="text" placeholder="Intitulé" formControlName="label" />
        </td>
        <td tiimeTableCell="chargeChoice">
          <app-code-and-label-select
            label=""
            [errorMessage]="lineForm.chargeChoiceErrorMessage"
            errorMessageMode="list"
            [allowEmptyOption]="false"
            [small]="true"
            [control]="lineForm.chargeChoice"
            [options]="contractAnnexLineCharges"
            (selectionChange)="chargeChoiceChange(lineForm, $event)"
          ></app-code-and-label-select>
        </td>
        <td tiimeTableCell="discountPercentage">
          @if (lineForm.chargeChoice.value === ContractAnnexLineCharge.discount) {
            <tiime-input-container contentId="discount" fixedLabel label="Remise" small>
              <input
                id="discount"
                appDigitOnly
                [decimal]="true"
                [roundDecimal]="false"
                placeholder="Remise"
                formControlName="discountPercentage"
              />
              <span tiimeSuffix>%</span>
            </tiime-input-container>
            @if (lineForm.discountPercentageErrorMessage) {
              <app-list-error [errorMessage]="lineForm.discountPercentageErrorMessage"></app-list-error>
            }
          }
        </td>
        @if (canRemoveLine()) {
          <td tiimeTableCell="actions">
            <button
              class="show-on-hover"
              type="button"
              tiime-button
              icon
              color="primary"
              tabindex="-1"
              tiimeTooltip="Retirer la ligne d'annexe"
              (click)="emitRemoveLine(i)"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove" inline="true"></mat-icon>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
